// @deprecated
import { localStorage } from '../../kodyl-js/client/web-storage';

export { localStorage };

export default localStorage;
